/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getAllUnits = () => {
  return progressApi.get(`/TagMeta/GetAllUnits${extractedPath}`);
};

export const getUnitsByTrainId = (trainId = 0) => {
  return progressApi.get(`/TagMeta/GetUnitsByTrainId${extractedPath}?id=${trainId}`);
};

export const createUnit = (unit: any) => {
  return progressApi.post(`/TagMeta/CreateUnit${extractedPath}`, unit);
};

export const updateUnit = (unit: any) => {
  return progressApi.post(`/TagMeta/UpdateUnit${extractedPath}`, unit);
};

export const deleteUnit = (id: any) => {
  return progressApi.get(`/TagMeta/DeleteUnit${extractedPath}?id=${id}`);
};